import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4 text-center">
      <h1 className="font-heading text-6xl md:text-8xl font-bold text-primary-500 mb-4">404</h1>
      <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
      <p className="text-sm text-foreground-400 mb-8">您访问的页面不存在或已被移除</p>
      <Link
        to="/"
        className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        返回首页
      </Link>
    </div>
  );
}